import { useCssVars as X, ref as d, computed as r, watch as w, onMounted as j, openBlock as m, createElementBlock as c, createElementVNode as i, createVNode as q, renderSlot as G, createCommentVNode as $, unref as T, normalizeStyle as v, withDirectives as z, vModelText as F, toDisplayString as L, pushScopeId as Z, popScopeId as H } from "vue";
import J from "./BaseIcon-BBkGiBfe.js";
import { t as K, u as Q } from "./useResponsive-NZB-WLRF.js";
import { c as Y, M as ee, L as te, X as le } from "./index-CheT0Wx_.js";
import { _ as ae } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const A = (l) => (Z("data-v-2e5f9167"), l = l(), H(), l), ie = { "data-html2canvas-ignore": "" }, ne = {
  class: "vue-data-ui-slicer-labels",
  style: { position: "relative", "z-index": "1" }
}, oe = {
  key: 0,
  style: { width: "100%", position: "relative" }
}, ue = {
  key: 0,
  class: "minimap",
  style: { width: "100%" }
}, re = ["xmlns", "viewBox"], se = ["id"], de = ["stop-color"], me = /* @__PURE__ */ A(() => /* @__PURE__ */ i("stop", {
  offset: "100%",
  "stop-color": "transparent"
}, null, -1)), ce = ["x", "width", "height", "rx", "fill"], he = ["d", "stroke", "fill"], ve = ["x2", "y1", "y2", "stroke"], pe = ["y2", "stroke"], fe = ["x1", "x2", "y2", "stroke"], ge = /* @__PURE__ */ A(() => /* @__PURE__ */ i("div", { class: "slider-track" }, null, -1)), be = ["min", "max"], ye = ["min", "max"], xe = {
  __name: "Slicer",
  props: {
    background: {
      type: String,
      default: "#FFFFFF"
    },
    borderColor: {
      type: String,
      default: "#FFFFFF"
    },
    fontSize: {
      type: Number,
      default: 14
    },
    labelLeft: {
      type: String,
      default: ""
    },
    labelRight: {
      type: String,
      default: ""
    },
    textColor: {
      type: String,
      default: "#1A1A1A"
    },
    inputColor: {
      type: String,
      default: "#1A1A1A"
    },
    max: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    selectColor: {
      type: String,
      default: "#4A4A4A"
    },
    useResetSlot: {
      type: Boolean,
      default: !1
    },
    valueStart: {
      type: [Number, String],
      default: 0
    },
    valueEnd: {
      type: [Number, String],
      default: 0
    },
    minimap: {
      type: Array,
      default: []
    },
    smoothMinimap: {
      type: Boolean,
      default: !1
    },
    minimapSelectedColor: {
      type: String,
      default: "#1f77b4"
    },
    minimapSelectionRadius: {
      type: Number,
      default: 12
    },
    minimapLineColor: {
      type: String,
      default: "#2D353C"
    },
    minimapSelectedColorOpacity: {
      type: Number,
      default: 0.2
    }
  },
  emits: ["update:start", "update:end", "reset"],
  setup(l, { emit: p }) {
    const e = l;
    X((a) => ({
      22433820: I.value,
      f2582738: h.value,
      "5216c256": V.value,
      "67092d94": l.selectColor,
      "3404ae22": R.value
    }));
    const n = d(e.min), o = d(e.max), b = r(() => !!e.minimap.length), y = d(Y()), P = r(() => {
      const a = e.max - e.min, u = (n.value - e.min) / a * 100, s = (o.value - e.min) / a * 100;
      return {
        left: `${u}%`,
        width: `${s - u}%`,
        background: e.selectColor
      };
    }), I = r(() => e.inputColor), R = r(() => e.background), V = r(() => `${e.selectColor}33`), h = r(() => e.borderColor);
    function x() {
      p("reset");
    }
    function E() {
      Number(n.value) > Number(o.value) - 1 && (n.value = Number(o.value) - 1), p("update:start", Number(n.value));
    }
    function B() {
      Number(o.value) < Number(n.value) + 1 && (o.value = Number(n.value) + 1), p("update:end", Number(o.value));
    }
    w(
      () => e.min,
      (a) => {
        Number(n.value) < Number(a) && (n.value = Number(a)), Number(o.value) < Number(a) && (o.value = Number(a));
      }
    ), w(
      () => e.max,
      (a) => {
        Number(n.value) > Number(a) && (n.value = Number(a)), Number(o.value) > Number(a) && (o.value = Number(a));
      }
    );
    const f = d(null), t = d({
      width: 1,
      height: 1
    }), S = d(null);
    j(() => {
      if (b.value) {
        const a = K(() => {
          const { width: u, height: s } = Q({
            chart: f.value
          });
          t.value.width = u, t.value.height = s - 47;
        });
        S.value = new ResizeObserver(a), S.value.observe(f.value);
      }
    });
    const N = r(() => e.minimap.length ? t.value.width / e.minimap.length : 0), g = r(() => ({
      x: N.value * e.valueStart,
      width: N.value * (e.valueEnd - e.valueStart)
    })), _ = r(() => {
      if (!e.minimap.length) return [];
      const a = Math.max(...e.minimap), u = Math.min(...e.minimap) - 10, s = a - (u > 0 ? 0 : u), C = e.minimap.map((D, U) => {
        const W = D - u;
        return {
          x: t.value.width / (e.minimap.length - 1) * U,
          y: t.value.height - W / s * (t.value.height * 0.9)
        };
      });
      return e.smoothMinimap ? ee(C) : te(C);
    }), k = r(() => e.max - e.min), M = r(() => ({
      left: `calc(${(n.value - e.min) / k.value * 100}%)`,
      color: e.textColor,
      fontSize: `${e.fontSize}px`,
      top: "-28px",
      pointerEvents: "none"
    })), O = r(() => ({
      left: `calc(${(o.value - e.min) / k.value * 100}%)`,
      color: e.textColor,
      fontSize: `${e.fontSize}px`,
      top: "28px",
      direction: "rtl",
      pointerEvents: "none"
    }));
    return (a, u) => (m(), c("div", ie, [
      i("div", ne, [
        l.valueStart > 0 || l.valueEnd < l.max ? (m(), c("div", oe, [
          l.useResetSlot ? G(a.$slots, "reset-action", {
            key: 1,
            reset: x
          }, void 0, !0) : (m(), c("button", {
            key: 0,
            "data-cy-reset": "",
            tabindex: "0",
            role: "button",
            class: "vue-data-ui-refresh-button",
            onClick: x
          }, [
            q(J, {
              name: "refresh",
              stroke: l.textColor
            }, null, 8, ["stroke"])
          ]))
        ])) : $("", !0)
      ]),
      i("div", {
        class: "double-range-slider",
        ref_key: "minimapWrapper",
        ref: f,
        style: { "z-index": "0" }
      }, [
        b.value ? (m(), c("div", ue, [
          (m(), c("svg", {
            xmlns: T(le),
            viewBox: `0 0 ${t.value.width < 0 ? 0 : t.value.width} ${t.value.height < 0 ? 0 : t.value.height}`
          }, [
            i("defs", null, [
              i("linearGradient", {
                id: y.value,
                x1: "0%",
                y1: "0%",
                x2: "0%",
                y2: "100%"
              }, [
                i("stop", {
                  offset: "0%",
                  "stop-color": `${l.minimapLineColor}50`
                }, null, 8, de),
                me
              ], 8, se)
            ]),
            i("rect", {
              x: g.value.x,
              y: "0",
              width: g.value.width < 0 ? 0 : g.value.width,
              height: t.value.height < 0 ? 0 : t.value.height,
              rx: l.minimapSelectionRadius,
              fill: `${l.minimapSelectedColor}`,
              style: v({ opacity: l.minimapSelectedColorOpacity })
            }, null, 12, ce),
            i("path", {
              d: `M0,${t.value.height} ${_.value} L${t.value.width},${t.value.height}Z`,
              stroke: `${l.minimapLineColor}`,
              fill: `url(#${y.value})`,
              "stroke-width": "1",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, he),
            i("line", {
              x1: 0,
              x2: t.value.width < 0 ? 0 : t.value.width,
              y1: t.value.height < 0 ? 0 : t.value.height,
              y2: t.value.height < 0 ? 0 : t.value.height,
              stroke: h.value,
              "stroke-width": "1"
            }, null, 8, ve),
            i("line", {
              x1: 0,
              x2: 0,
              y1: 0,
              y2: t.value.height < 0 ? 0 : t.value.height,
              stroke: h.value,
              "stroke-width": "3"
            }, null, 8, pe),
            i("line", {
              x1: t.value.width < 0 ? 0 : t.value.width,
              x2: t.value.width < 0 ? 0 : t.value.width,
              y1: 0,
              y2: t.value.height < 0 ? 0 : t.value.height,
              stroke: h.value,
              "stroke-width": "3"
            }, null, 8, fe)
          ], 8, re))
        ])) : $("", !0),
        ge,
        i("div", {
          class: "range-highlight",
          style: v(P.value)
        }, null, 4),
        z(i("input", {
          type: "range",
          min: l.min,
          max: l.max,
          "onUpdate:modelValue": u[0] || (u[0] = (s) => n.value = s),
          onInput: E
        }, null, 40, be), [
          [F, n.value]
        ]),
        i("div", {
          class: "thumb-label thumb-label-left",
          style: v(M.value)
        }, L(l.labelLeft), 5),
        z(i("input", {
          type: "range",
          min: l.min,
          max: l.max,
          "onUpdate:modelValue": u[1] || (u[1] = (s) => o.value = s),
          onInput: B
        }, null, 40, ye), [
          [F, o.value]
        ]),
        i("div", {
          class: "thumb-label thumb-label-right",
          style: v(O.value)
        }, L(l.labelRight), 5)
      ], 512)
    ]));
  }
}, $e = /* @__PURE__ */ ae(xe, [["__scopeId", "data-v-2e5f9167"]]);
export {
  $e as S
};
